import { Button, Divider, Flex, Form, Input, Modal, Tag, Typography } from 'antd';
import styled from 'styled-components';

import { EditOutlined } from '@ant-design/icons';

export const Divider16Margin = styled(Divider)`
  margin: 16px 0;
`;

interface DividerNoLineProps {
  $margin?: string;
}

export const DividerNoLine = styled(Divider)<DividerNoLineProps>`
  border: none;
  margin: ${({ $margin }) => $margin};
`;

export const Divider100height = styled(Divider)`
  height: 100%;
`;

export const Flex100Width = styled(Flex)`
  width: 100%;
`;

export const FlexGap8 = styled(Flex).attrs({
  gap: 8,
})``;

export const FlexGap16 = styled(Flex).attrs({
  gap: 16,
})``;

export const FlexGap8JustifyEnd = styled(Flex).attrs({
  gap: 8,
  justify: 'flex-end',
})``;

export const FlexGap16AlignCenter = styled(Flex).attrs({
  gap: 16,
  align: 'center',
})``;

export const FormItemWithHiddenLabel = styled(Form.Item)`
  label {
    visibility: hidden !important;
  }
`;

export const FormItem100Width = styled(Form.Item)`
  width: 100%;
`;

interface FormItem50or100WidthProps {
  $isDesktop?: boolean;
}
export const FormItem50or100Width = styled(Form.Item)<FormItem50or100WidthProps>`
  width: ${({ $isDesktop }) => ($isDesktop ? '50%' : '100%')};
`;

interface LinkButtonProps {
  $noRightPadding?: boolean;
}

export const LinkButton = styled(Button)<LinkButtonProps>`
  color: ${({ theme }) => theme.colorPrimary};
  padding-left: 8px;
  padding-right: ${({ $noRightPadding }) => ($noRightPadding ? '0px' : '8px')};
  svg {
    fill: ${({ theme }) => theme.colorPrimary};
  }
`;

export const EditButton = styled(Button).attrs((props) => ({
  type: props.disabled ? 'text' : 'link',
  icon: <EditOutlined />,
  style: { background: 'transparent' },
}))`
  color: ${({ theme }) => theme.colorPrimary};
  font-size: 24px;
`;

interface StyledPopoverHeaderProps {
  $borderless?: boolean;
}

export const StyledPopoverHeader = styled(Flex).attrs({
  justify: 'space-between',
  align: 'center',
})<StyledPopoverHeaderProps>`
  padding: 16px 20px;
  border-bottom: ${({ $borderless, theme }) => ($borderless ? 'none' : `1px solid ${theme.colorBorderSecondary}`)};
`;

interface SearchFormProps {
  $isDesktop?: boolean;
}

export const SearchHeader = styled(FlexGap8)<SearchFormProps>`
  width: 100%;
  .ant-input-group-wrapper {
    max-width: ${({ $isDesktop }) => ($isDesktop ? '318px' : '100%')};
  }
  .ant-input-prefix {
    .anticon {
      font-size: 25px;
      color: ${({ theme }) => theme.colorTextDescription};
      margin-right: 6px;
    }
  }
  svg {
    font-size: 18px;
  }
  .anticon-search {
    svg {
      font-size: 16px;
    }
  }
`;

export const SearchForm = styled(Input.Search)<SearchFormProps>`
  .ant-btn {
    ${({ $isDesktop }) =>
      !$isDesktop &&
      `
    border: none;
    border-radius: 15px !important;
    background: none !important;
  `}
  }
`;

export const PrimaryTag = styled(Tag)`
  color: ${({ theme }) => theme.colorInfo};
  border-color: ${({ theme }) => theme.colorInfoBorder};
  background-color: ${({ theme }) => theme.colorInfoBg};
`;

interface CustomWidthTagProps {
  $width: number;
}

export const CustomWidthTag = styled(Tag)<CustomWidthTagProps>`
  width: ${({ $width }) => `${$width}px`};
  text-align: center;
`;

interface EllipsisTagProps {
  $maxWidth?: number;
}

export const EllipsisTag = styled(Tag)<EllipsisTagProps>`
  max-width: ${({ $maxWidth }) => `${$maxWidth || 150}px`};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
`;

export const StyledModalWithHeaderBorder = styled(Modal)`
  .ant-modal-header {
    border-bottom: 1px solid ${({ theme }) => theme.colorBorder};
    padding: 20px 24px 8px 24px;
    margin-bottom: 0;
  }
  .ant-modal-body {
    padding: 20px 24px;
  }
  .ant-modal-content {
    padding: 0;
  }
  .ant-modal-footer {
    margin-top: 0;
    padding: 0px 24px 20px 24px;
  }
`;

interface FormWrapperProps {
  $isDesktop: boolean;
}

export const FormWrapper = styled.div<FormWrapperProps>`
  width: 100%;
  align-self: stretch;
  overflow-y: auto;
  overflow-x: hidden;
  margin-bottom: ${({ $isDesktop }) => ($isDesktop ? 0 : '62px')};
`;

export const MobileButtonsWrapper = styled(Flex)`
  position: fixed;
  z-index: 1000;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 110px;
  gap: 12px;
  justify-content: center;
  align-items: end;
  padding: 16px 20px;
  background: ${({ theme }) => `linear-gradient(180deg, rgba(244, 244, 244, 0.00) 0%, ${theme.colorBgLayout} 56%)`};
`;

export const StyledModalWithBorder = styled(Modal)`
  .ant-modal-content {
    padding: 0;
  }
  .ant-modal-header {
    border-bottom: 1px solid ${({ theme }) => theme.colorBorder};
    padding: 20px 24px 8px 24px;
    margin-bottom: 0;
  }
  .ant-modal-body {
    padding: 20px 24px;
  }
  .ant-modal-footer {
    padding: 0px 24px 20px 24px;
    margin-top: 0;
  }
`;

export const GridList = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(295px, 1fr));
  gap: 16px;
`;

export const TitleNoMargin = styled(Typography.Title).attrs({
  style: {
    marginBottom: 0,
  },
})``;

export const StyledCardWrapper = styled.div`
  .ant-card {
    border-color: ${({ theme }) => theme.colorBorderSecondary};
  }
  .ant-card:has(a:focus) {
    border-color: ${({ theme }) => theme.colorPrimaryBorder};
  }
  .ant-card:hover {
    border-color: ${({ theme }) => theme.colorPrimaryBorder};
    background-color: ${({ theme }) => theme.controlItemBgActive};
    box-shadow: none;
  }
`;
